export default "__VITE_PUBLIC_ASSET__4fd1d28b__"